$('[data-faq-panel]').on('click', (e) => {
  const $this  = $(e.currentTarget);
  const $panel = $($this.data('faqPanel'));

  $this
    .addClass('active')
    .siblings()
    .removeClass('active');

  $panel
    .addClass('show')
    .siblings()
    .removeClass('show');
});

$('[data-faq-collapse]').on('click', (e) => {
  const $collapse = $(e.currentTarget);
  $collapse.toggleClass('collapsed', !$collapse.hasClass('collapsed'));
});



// WEBPACK FOOTER //
// app/javascript/frontend/faq.js